type ApplicationTypeUser = "RPE" | "Merchant";

const valuesByTypeUser: Record<
  ApplicationTypeUser,
  { name: string; value: number }
> = {
  RPE: {
    value: 2,
    name: "RPE",
  },
  Merchant: {
    value: 1,
    name: "Merchant",
  },
};

export function isTypeUser(
  desiredTypeUser: ApplicationTypeUser,
  currentUserTypeUser?: string | number
): boolean {
  if (!currentUserTypeUser) {
    return false;
  }
  const desiredValues = valuesByTypeUser[desiredTypeUser];

  return (
    currentUserTypeUser === desiredValues.name ||
    currentUserTypeUser === desiredValues.value
  );
}
